module.exports = __webpack_public_path__ + "static/img/logo-300-150.602c239.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/common/logo-300-150.png
// module id = b9bG
// module chunks = 1